import React from 'react';
//import css from './css.module.less';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import {
  Field,
  // itemWrapperErrorDisplayAdaptor,
  antdErrorDisplayAdaptor,
} from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  ButtonText,
  buttonThemeUuid,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page-revamp/constant';
import { sectionProps } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
//import { get } from 'lodash';
import { Input, OriSelect } from '@/src/components/Antd';
import { get } from 'lodash';
import CountWordsWithFormItem from 'src/components/CountWords/CountWordsWithFormItem';
import { checkButtonText } from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page-revamp/validator';
import { buttonText } from '@/src/tools/contentModulesFieldName';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import { getEditableStatus } from '../../SalesChannelEditorAllProductPage-revamp/util';

import {
  buttonStyleFields,
  buttonStyleResetFields,
  buttonStyleResponsiveResetFields,
} from '../fields';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useSelector } from 'react-redux';
import { editable } from '@/src/tools/contentModulesFieldName';

const selectN = [buttonText, buttonThemeUuid];
const textN = [buttonText, buttonText];

const BT = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled, options = [] } = props;
  const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());
  const isPc = breakpoint === EPreviewSize.WIDE;

  const handleOnResetTabletAndMobile = () => {
    const isTabletEditing = props.tabletForm.getFieldValue([
      `${ButtonText}_${editable}`,
    ]);
    const isMobileEditing = props.mobileForm.getFieldValue([
      `${ButtonText}_${editable}`,
    ]);
    if (isTabletEditing) {
      props.handleOnSectionReset(buttonStyleResetFields, EPreviewSize.TABLET);
    } else {
      //props.handleOnSectionReset(buttonStyleFields, EPreviewSize.TABLET);
      props.handleOnSectionReset(buttonStyleResetFields, EPreviewSize.TABLET);
    }
    if (isMobileEditing) {
      props.handleOnSectionReset(buttonStyleResetFields, EPreviewSize.MOBILE);
    } else {
      props.handleOnSectionReset(buttonStyleResetFields, EPreviewSize.MOBILE);
      // props.handleOnSectionReset(buttonStyleFields, EPreviewSize.MOBILE);
    }
  };

  const handleOnReset = () => {
    props.handleOnSectionReset(
      isPc ? buttonStyleFields : buttonStyleResponsiveResetFields,
      breakpoint,
    );
    if (isPc) {
      handleOnResetTabletAndMobile();
    }
  };

  return (
    <Wrapper id={ButtonText} breakpoint={breakpoint}>
      <Field shouldUpdate>
        {(_, meta, { getFieldValue }) => {
          const is_editable =
            getEditableStatus(getFieldValue, ButtonText, breakpoint) &&
            isOnPrimaryLanguage;
          return (
            <BlockTitle
              id={ButtonText}
              title={getI18n('general.buttonText')}
              breakpoint={breakpoint}
              onReset={() => {
                handleOnReset();
              }}
              onCopy={() =>
                props.handleOnSectionCopy(buttonStyleFields, breakpoint)
              }
              headerErrorDependencies={[[buttonText]]}
              validator={(data) => {
                const text = get(data, textN);
                return checkButtonText(text);
              }}
              dotsFunction={[
                {
                  onClick: () => {
                    handleOnReset();
                  },
                  key: 'Reset',
                  body: getI18n('general.resetSetting'),
                  isDangerous: true,
                },
              ]}
              dotsDisabled={!is_editable}
            />
          );
        }}
      </Field>

      <Section {...sectionProps}>
        <Field shouldUpdate>
          {(props, meta, { getFieldValue }) => {
            const is_editable =
              getEditableStatus(getFieldValue, ButtonText, breakpoint) &&
              isOnPrimaryLanguage;
            return (
              <ItemWrapper
                title={getI18n('salesChannelContent.index.buttonTheme')}>
                <Field name={selectN} initialValue={null}>
                  <OriSelect
                    disabled={disabled || !is_editable}
                    size='large'
                    //   value={moduleWidth}
                    //   onChange={handleOnModuleWidthChange}
                  >
                    <OriSelect.Option value={null}>
                      {getI18n('general.status.none')}
                    </OriSelect.Option>
                    {(options || []).map((i) => {
                      const { label, value } = i;
                      return (
                        <OriSelect.Option value={value} key={value}>
                          {label}
                        </OriSelect.Option>
                      );
                    })}
                  </OriSelect>
                </Field>
              </ItemWrapper>
            );
          }}
        </Field>

        <ItemWrapper
          title={`${getI18n('general.content.text')}*`}
          rightPart={<CountWordsWithFormItem keyName={textN} maxCount={40} />}>
          <Field
            name={textN}
            rules={[
              {
                validator: async (rules: any, value: any) => {
                  const res = checkButtonText(value);

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                },
              },
            ]}>
            {(props, m) => {
              const eP = antdErrorDisplayAdaptor(m);

              return (
                <Input
                  maxLength={40}
                  size='large'
                  {...props}
                  {...m}
                  {...eP}
                  disabled={breakpoint !== EPreviewSize.WIDE}
                />
              );
            }}
          </Field>
        </ItemWrapper>
      </Section>
    </Wrapper>
  );
};
export default BT;
